export default "__VITE_ASSET__ccvDQhXY__"